<template>
    <v-card class="px-5 px-md-13 px-sm-7 px-lg-16 py-5 py-md-8 py-sm-5 py-lg-10 ma=0" >
      <v-row>
        <v-col cols="12">
          <header-medium :text="workflow_header"></header-medium>
        </v-col>
      </v-row>
      <v-row v-if="!revoked" justify="center">
        <v-col cols="12" sm="12">
          <info-alert :text="summaryText" :color="mainColor"></info-alert>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12">
          <header-small :text="$t('DetailsPage.header.signatory')"></header-small>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="6">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("DetailsPage.labels.first_name")
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                workflow.first_name
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" sm="6">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("DetailsPage.labels.last_name")
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                workflow.last_name
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12">
          <header-small :text="$t('Check.Files')"></header-small>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12">
          <v-data-table :headers="headers" :items="files" item-key="id" sort-by="name" sortDesc :page.sync="page"
            :items-per-page="itemsPerPage" @page-count="pageCount = $event" class="elevation-1" :footer-props="{
              disableItemsPerPage: true,
              itemsPerPageOptions: [],
              itemsPerPageText: '',
            }">
            <template v-slot:item.actions="{ item }">
              <v-tooltip top key="download">
                <template v-if="!revoked" v-slot:activator="{ on, attrs }">
                  <v-icon class="custom-icon2" @click="download(item)" v-bind="attrs" v-on="on">
                    mdi-file-download-outline
                  </v-icon>
                </template>
                <span>{{ $t("Tooltips.download") }}</span>
              </v-tooltip>
            </template>
            <template v-slot:no-data>
              {{ $t("Headers.no_data") }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-container class="text-center ma-0 pa-0 mw-100">
            {{ $t('RedirectQES.revoke_hint') }}
            <a target="_blank" href="https://signing.sign8.eu/revoke" @click.stop>
              {{ $t("RedirectQES.revoke_url") }}
            </a>
            {{ $t('RedirectQES.revoke_hint_2') }}
          </v-container>
          <v-container class="text-center ma-0 pa-0 mw-100">
            {{ $t('RedirectQES.more_info') }}
            <a target="_blank" href="https://sign8.eu/trust" @click.stop>
              {{ $t("RedirectQES.trust_url") }}
            </a>
          </v-container>
        </v-col>
      </v-row>
    </v-card>
</template>

<script>
import HeaderMedium from "../../components/ui/text/HeaderMedium.vue";
import i18n from "../../i18n";
import InfoAlert from "../../components/ui/other/InfoAlert";
import HeaderSmall from "../../components/ui/text/HeaderSmall";
import fileDownload from "js-file-download";

export default {
  name: "workflow-summary",
  components: {
    HeaderMedium,
    HeaderSmall,
    InfoAlert,
  },
  props: {
    files: Array,
    revoked: Boolean,
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      workflow: {},
      workflow_header: "",
      mainColor: this.$vuetify.theme.themes.light.primary,
      headers: [
        {
          value: "name",
          text: i18n.t("Headers.file_name"),
          sortable: true,
        },
        {
          value: "actions",
          text: "",
        },
      ],
      summaryText: "",
    };
  },
  computed: {
    currentWorkflow() {
      return this.$store.state.auth.workflow;
    },
  },
  created() {
    this.workflow = this.currentWorkflow;
    this.summaryText =
      this.workflow.status === "FINISHED"
        ? i18n.t("Summary.Info_finished")
        : i18n.t("Summary.Info");
    this.workflow_header =
      i18n.t("Headers.workflow") + ": " + this.workflow.name;
  },
  methods: {
async download(file) {
      try {
        this.$store.commit("set_loading", true);

        if (file.id != "audit_report") {
          const fileContentString = JSON.parse(file.file);
          const byteArray = new Uint8Array(fileContentString.length);
          for (let i = 0; i < fileContentString.length; i++) {
            byteArray[i] = fileContentString.charCodeAt(i);
          }
          const blob = new Blob([byteArray], {
            type: "application/octet-stream",
          });
          fileDownload(blob, file.name);
        } else {
          const base64Response = await fetch(`data:application/pdf;base64,${file.file}`);
          const blob = await base64Response.blob();
          const linkSource = URL.createObjectURL(blob);
          const downloadLink = document.createElement("a");
          downloadLink.href = linkSource;
          downloadLink.download = file.name;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          URL.revokeObjectURL(linkSource);
        }
        this.$store.commit("set_loading", false);
      } catch (e) {
        this.$store.commit("set_loading", false);
      }
    },
  },
};
</script>